export default {
  LOCAL_STORAGE_KEYS: {
    stakedStore: 'staked-store'
  },
  VERSION: {
    stakedStore: '0.0.2'
  }
};
